// src/stores/prescriptionStore.js
import { create } from 'zustand'

export const useDemoStore = create((set) => ({
  // Initial States
 demoMessage:{
    status:false,
    severity:"",
    description:"",
    action:false
  },
  demoDialog:{
    status:false,
    description:""
  },
  
  // Actions
  setDemoMessage: (demoMessage) => set({ demoMessage }),
  setDemoDialog: (demoDialog) => set({ demoDialog })
}))


